export default __webpack_public_path__ + "static/media/G0002.41c68cd2.png";